/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactSiegeGridDto
 */
export interface ContactSiegeGridDto {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeGridDto
     */
    idcontactSiege?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeGridDto
     */
    idcontact?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    dateNaissance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSiegeGridDto
     */
    principal?: boolean;
}

/**
 * Check if a given object implements the ContactSiegeGridDto interface.
 */
export function instanceOfContactSiegeGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeGridDtoFromJSON(json: any): ContactSiegeGridDto {
    return ContactSiegeGridDtoFromJSONTyped(json, false);
}

export function ContactSiegeGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontactSiege': !exists(json, 'idcontactSiege') ? undefined : json['idcontactSiege'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : json['dateNaissance'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'principal': !exists(json, 'principal') ? undefined : json['principal'],
    };
}

export function ContactSiegeGridDtoToJSON(value?: ContactSiegeGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontactSiege': value.idcontactSiege,
        'idcontact': value.idcontact,
        'idsiegeSocial': value.idsiegeSocial,
        'nom': value.nom,
        'prenom': value.prenom,
        'dateNaissance': value.dateNaissance,
        'fonction': value.fonction,
        'gsm': value.gsm,
        'telephone': value.telephone,
        'email': value.email,
        'principal': value.principal,
    };
}

